import { type ComponentType, type ReactElement, lazy } from 'react';
import { Placeholder } from './components/Placeholder';

/**
 * Seiten werden erst geladen, wenn man sie öffnet (Code-Splitting): ECharts
 * und MapLibre stecken so nur in den Bündeln der Seiten, die sie zeigen. Den
 * Ladezustand zeigt `App.tsx` im Inhalt der Shell.
 */
const page = <K extends string>(load: () => Promise<Record<K, ComponentType>>, name: K) => lazy(() => load().then((m) => ({ default: m[name] })));

const EinstellungenPage = page(() => import('./pages/einstellungen/EinstellungenPage'), 'EinstellungenPage');
const HeutePage = page(() => import('./pages/heute/HeutePage'), 'HeutePage');
const MehrPage = page(() => import('./pages/mehr/MehrPage'), 'MehrPage');
const AnalysePage = page(() => import('./pages/analyse/AnalysePage'), 'AnalysePage');
const HealthPage = page(() => import('./pages/health/HealthPage'), 'HealthPage');
const AktivitaetPage = page(() => import('./pages/aktivitaet/AktivitaetPage'), 'AktivitaetPage');
const AktivitaetenPage = page(() => import('./pages/aktivitaeten/AktivitaetenPage'), 'AktivitaetenPage');
const KartenPage = page(() => import('./pages/karten/KartenPage'), 'KartenPage');
const ZielePage = page(() => import('./pages/ziele/ZielePage'), 'ZielePage');
const WrappedPage = page(() => import('./pages/wrapped/WrappedPage'), 'WrappedPage');
const PlanungPage = page(() => import('./pages/planung/PlanungPage'), 'PlanungPage');
const AusruestungPage = page(() => import('./pages/ausruestung/AusruestungPage'), 'AusruestungPage');
const SaisonPage = page(() => import('./pages/saison/SaisonPage'), 'SaisonPage');

/**
 * Seiten der App. Jedes Arbeitspaket ersetzt nur seine eigenen Zeilen hier
 * und legt seine Seite unter `pages/<bereich>/` ab.
 */
export const ROUTES: { path: string; element: ReactElement }[] = [
  { path: '/', element: <HeutePage /> },
  { path: '/aktivitaeten', element: <AktivitaetenPage /> },
  { path: '/aktivitaeten/:id', element: <AktivitaetPage /> },
  { path: '/analyse', element: <AnalysePage /> },
  { path: '/health', element: <HealthPage /> },
  { path: '/ziele', element: <ZielePage /> },
  { path: '/planung', element: <PlanungPage /> },
  { path: '/saison', element: <SaisonPage /> },
  { path: '/karten', element: <KartenPage /> },
  { path: '/ausruestung', element: <AusruestungPage /> },
  { path: '/wrapped', element: <WrappedPage /> },
  { path: '/wrapped/:periode', element: <WrappedPage /> },
  { path: '/einstellungen', element: <EinstellungenPage /> },
  { path: '/mehr', element: <MehrPage /> },
];
